import React from 'react';
import YouTube from 'react-youtube';
import LazyDiv from '../lazy/lazydiv';

const YoutubePlayer = (props) => {

    const opts = {
        height: '500',
        width: '100%',
        playerVars: {
          // https://developers.google.com/youtube/player_parameters
          autoplay: 1
          // listType:"playlist",
          // list:"PLNI-cJa63vBJPJHPmUo3EBlsHNdMABQ3S"
        },
      };
    return (
        <LazyDiv orient={"landscape"} className={props.header?"boxClassTop":"boxClass"}>
            <YouTube videoId={props.videoId} opts={opts} loading={"lazy"} />
        </LazyDiv>
    );
};

export default YoutubePlayer;